export default [
  {
    path: '/bluetooth-earphone',
    component: () => import('@/views/bluetooth/earphone/Index.vue'),
    name: 'bluetooth.earphone',
    meta: {
      title: '我的穿戴设备',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-control',
    component: () => import('@/views/bluetooth/earphone/Control.vue'),
    name: 'bluetooth.earphone.control',
    meta: {
      title: '设备',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-arousalWord',
    component: () => import('@/views/bluetooth/earphone/ArousalWord.vue'),
    name: 'bluetooth.earphone.arousalWord',
    meta: {
      title: '唤醒词',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-Remark',
    component: () => import('@/views/bluetooth/earphone/Remark.vue'),
    name: 'bluetooth.earphone.remark',
    meta: {
      title: '备注',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-explain',
    component: () => import('@/views/bluetooth/earphone/Explain.vue'),
    name: 'bluetooth.earphone.explain',
    meta: {
      title: '操作说明',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-find',
    component: () => import('@/views/bluetooth/earphone/Find.vue'),
    name: 'bluetooth.earphone.find',
    meta: {
      title: '发现新设备',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-help',
    component: () => import('@/views/bluetooth/earphone/Help.vue'),
    name: 'bluetooth.earphone.help',
    meta: {
      title: '帮助',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-helpFeedback',
    component: () => import('@/views/bluetooth/earphone/HelpFeedback.vue'),
    name: 'bluetooth.earphone.helpFeedback',
    meta: {
      title: '意见反馈',
      backgroundClass: 'bg-white',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-helpGuide',
    component: () => import('@/views/bluetooth/earphone/HelpGuide.vue'),
    name: 'bluetooth.earphone.helpGuide',
    meta: {
      title: '产品手册',
      backgroundClass: 'bg-white',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-about',
    component: () => import('@/views/bluetooth/earphone/About.vue'),
    name: 'bluetooth.earphone.about',
    meta: {
      title: '关于',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-agreementPrivacy',
    component: () => import('@/views/bluetooth/earphone/AgreementPrivacy.vue'),
    name: 'bluetooth.earphone.agreementPrivacy',
    meta: {
      title: '隐私协议',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-agreementSdk',
    component: () => import('@/views/bluetooth/earphone/AgreementSdk.vue'),
    name: 'bluetooth.earphone.agreementSdk',
    meta: {
      title: '第三方sdk',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-agreementUser',
    component: () => import('@/views/bluetooth/earphone/AgreementUser.vue'),
    name: 'bluetooth.earphone.agreementUser',
    meta: {
      title: '用户协议',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-servicePoint',
    component: () => import('@/views/bluetooth/earphone/ServicePoint.vue'),
    name: 'bluetooth.earphone.servicePoint',
    meta: {
      title: '售后服务点',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-upgrade',
    component: () => import('@/views/bluetooth/earphone/Upgrade.vue'),
    name: 'bluetooth.earphone.upgrade',
    meta: {
      title: '固件升级',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-upgradeProcedure',
    component: () => import('@/views/bluetooth/earphone/UpgradeProcedure.vue'),
    name: 'bluetooth.earphone.upgradeProcedure',
    meta: {
      title: '固件升级',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/bluetooth-earphone-volume',
    component: () => import('@/views/bluetooth/earphone/Volume.vue'),
    name: 'bluetooth.earphone.volume',
    meta: {
      title: '音量设置',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
];
